// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"497":"ae14a399","624":"cbd28835","631":"8d22cc0c","651":"4cff216a","810":"83c9dcc0","897":"0f0581e1","902":"a8364212","984":"e04d8d70"}[chunkId] + ".chunk.js";
};